<template>
  <div :key="this.$route.fullPath">
    <TagsViews></TagsViews>
    <router-view />
  </div>
</template>

<script>
import TagsViews from "./components/tagsViews";
export default {
  name: "Layout",
  components: {
    TagsViews,
  },
};
</script>

<style scoped lang="scss"></style>
